import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "reactstrap";
import { withTranslation } from "react-i18next";
import DeveloperTicketTable from "./DeveloperTicketTable";
import AddDeveloperTicket from "./AddDeveloperTicket";
import { getDeveloperTickets } from "helpers/fakebackend_helper";

const DeveloperTickets = () => {
  document.title = "Developer Tickets | CurbDash";

  const [tickets, setTickets] = useState([]);
  const user = JSON.parse(localStorage.getItem("authUser"));

  const loadTickets = async () => {
    try {
      const { data } = await getDeveloperTickets(user.token);
      setTickets(data || []);
    } catch (err) {
      console.error("Error loading tickets:", err);
    }
  };

  useEffect(() => {
    loadTickets();
  }, []);

  return (
    <div className="page-content" style={{marginTop: -70}}>
      <Container fluid>
        <Row className="d-flex">
          <Col xl={12}>
            <AddDeveloperTicket onSave={loadTickets} />
          </Col>
          <Col xl={12}>
            <DeveloperTicketTable tickets={tickets} />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

DeveloperTickets.propTypes = {
  t: PropTypes.any,
};

export default withTranslation()(DeveloperTickets);